// removed by extract-text-webpack-plugin
module.exports = {"Radish":"#C20026","error":"Gab8875 Gd05560","icon":"G55bde3 Gb69063","errorIcon":"G86774e G55bde3 Gb69063 Gd28033"};